// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"076ce70b","35":"757c7a89","71":"72ed8881","277":"47727262","411":"610c2a61","502":"70e352e2","527":"7582b1df","557":"a9b2a1d1","845":"f1960386","934":"f662addf"}[chunkId] + ".chunk.js";
};